<template>
  <div class="diagram-page">
    <!-- SQL 编辑器 -->
    <div class="editor-panel">
      <div class="panel-header">
        <div class="panel-title">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="panel-icon">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"/>
          </svg>
          <span>SQL 编辑器</span>
        </div>
        <button class="btn-history" @click="showHistoryDialog = true">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          历史记录
        </button>
      </div>
      <textarea v-model="sql" class="sql-editor" placeholder="在此输入 SQL 语句..."></textarea>
      <div class="panel-footer">
        <button class="btn-primary" @click="generateER">
          <span class="btn-content">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 21h14v-5H5v5zM12 16v-5M12 11a3 3 0 100-6 3 3 0 000 6zM7 16l-3-6M4 10a2 2 0 100-4 2 2 0 000 4zM17 16l3-6M20 10a2 2 0 100-4 2 2 0 000 4z"/></svg>
            单个 ER 图
          </span>
          <span class="btn-points">（消耗{{ pointsConfig.singleErDiagram }}积分）</span>
        </button>
        <button class="btn-secondary" @click="generateTable">
          <span class="btn-content">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"/></svg>
            生成三线表
          </span>
          <span class="btn-points">（消耗{{ pointsConfig.threeLineTable }}积分）</span>
        </button>
        <button class="btn-ai" @click="generateOverallER">
          <span class="btn-content">
            <img src="@/assets/ai-logo.png" alt="AI" class="ai-icon" />
            总体 ER 图
          </span>
          <span class="btn-points">（消耗{{ pointsConfig.overallErDiagram }}积分）</span>
        </button>
      </div>
    </div>

    <!-- 预览区 -->
    <div class="preview-panel">
      <div class="tabs">
        <button :class="['tab', activeTab === 'er' ? 'active' : '']" @click="activeTab = 'er'">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 21h14v-5H5v5zM12 16v-5M12 11a3 3 0 100-6 3 3 0 000 6zM7 16l-3-6M4 10a2 2 0 100-4 2 2 0 000 4zM17 16l3-6M20 10a2 2 0 100-4 2 2 0 000 4z"/></svg>
          单个 ER 图预览
        </button>
        <button :class="['tab', activeTab === 'table' ? 'active' : '']" @click="activeTab = 'table'">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"/></svg>
          三线表预览
        </button>
        <button :class="['tab', activeTab === 'overall' ? 'active' : '']" @click="activeTab = 'overall'">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/></svg>
          总体 ER 图预览
        </button>
      </div>

      <div class="preview-content">
        <div v-show="activeTab === 'er'" class="preview-area">
          <er-diagram ref="erDiagram" @export="handleExportDiagram" />
        </div>
        <div v-show="activeTab === 'overall'" class="preview-area">
          <er-all ref="overallErDiagram" @export="handleExportDiagram" />
        </div>
        <div v-show="activeTab === 'table'" class="preview-area">
          <table-info ref="tableInfo" />
        </div>
      </div>
    </div>

    <!-- 历史记录模态框 -->
    <el-dialog
      title="历史生成记录"
      :visible.sync="showHistoryDialog"
      width="900px"
      @open="loadHistoryFromLocal">
      <div class="history-header">
        <div class="history-title">共 {{ totalRecords }} 条记录</div>
        <el-button
          type="danger"
          @click="clearHistory"
          :disabled="totalRecords === 0">
          清空历史记录
        </el-button>
      </div>
      <el-table size="small" border :data="historyList" style="width: 100%">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="timestamp" label="生成时间" width="180" align="center">
          <template slot-scope="{ row }">
            {{ formatTime(row.timestamp) }}
          </template>
        </el-table-column>
        <el-table-column prop="content" label="SQL内容" align="center">
          <template slot-scope="{ row }">
            <el-button size="small" type="text" @click="viewSqlDetail(row.content)">
              查看SQL
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="{ row }">
            <el-button size="small" type="primary" @click="loadHistory(row)">
              加载
            </el-button>
            <el-button size="small" type="danger" @click="deleteHistory(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :total="totalRecords"
          @current-change="handlePageChange"
          layout="prev, pager, next" />
      </div>
    </el-dialog>

    <!-- SQL详情模态框 -->
    <el-dialog
      title="SQL详情"
      :visible.sync="showSqlDetailDialog"
      width="800px">
      <div class="sql-detail-content">
        <pre>{{ currentSqlDetail }}</pre>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSqlDetailDialog = false">关闭</el-button>
        <el-button type="primary" @click="copySqlDetail">复制SQL</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ErDiagram from '@/components/ErDiagram.vue'
import ErAll from '@/components/ErAll.vue'
import TableInfo from '@/components/TableInfo.vue'

export default {
  name: 'Diagram',
  components: {
    ErDiagram,
    ErAll,
    TableInfo
  },
  data() {
    return {
      activeTab: 'er',
      showHistoryDialog: false,
      showSqlDetailDialog: false,
      currentSqlDetail: '',
      historyList: [],
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0,
      pointsConfig: {
        singleErDiagram: 3,
        threeLineTable: 3,
        overallErDiagram: 4
      },
      sql: `CREATE TABLE Students (
    student_id INT PRIMARY KEY COMMENT '学号',
    name VARCHAR(50) NOT NULL COMMENT '姓名',
    major VARCHAR(100) COMMENT '专业',
    enrollment_date DATE COMMENT '入学日期'
) COMMENT '学生表';

CREATE TABLE Courses (
    course_id INT PRIMARY KEY COMMENT '课程号',
    title VARCHAR(100) NOT NULL COMMENT '课程名称',
    credits INT COMMENT '学分'
) COMMENT '课程表';

CREATE TABLE Enrollments (
    enrollment_id INT PRIMARY KEY COMMENT '选课记录ID',
    student_id INT COMMENT '学号',
    course_id INT COMMENT '课程号',
    grade DECIMAL(3,1) COMMENT '成绩',
    FOREIGN KEY (student_id) REFERENCES Students(student_id),
    FOREIGN KEY (course_id) REFERENCES Courses(course_id)
) COMMENT '选课记录表';`
    }
  },
  created() {
    this.increasePageView()
    this.loadHistoryFromLocal()
    this.loadPointsConfig()
  },
  mounted() {
    // 页面加载时自动加载最近一个历史记录
    this.loadLatestHistory()
  },
  methods: {
    // 加载积分配置
    async loadPointsConfig() {
      try {
        const response = await this.request.get('/er-diagram/points-config')
        if (response.code === '200' && response.data) {
          this.pointsConfig = response.data
        }
      } catch (error) {
        console.error('加载积分配置失败:', error)
      }
    },

    async callApi(type) {
      if (!this.sql.trim()) {
        this.$message.warning('请输入SQL建表语句')
        return
      }

      this.activeTab = type

      // 根据类型选择不同的接口
      let endpoint = '/er-diagram/parse'
      if (type === 'table') {
        endpoint = '/er-diagram/table'
      }

      try {
        const response = await this.request.post(endpoint, { sql: this.sql })
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          if (type === 'er') {
            this.$refs.erDiagram.updateDiagram(response.data)
            this.$message.success('ER图生成成功')
            // 保存历史记录，标记已生成单个ER图，并保存图表数据
            this.saveHistory(this.sql, { er: true }, { er: response.data })
          } else if (type === 'overall') {
            this.$refs.overallErDiagram.updateDiagram(response.data)
            this.$message.success('总体ER图生成成功')
            // 保存历史记录，标记已生成总体ER图，并保存图表数据
            this.saveHistory(this.sql, { overall: true }, { overall: response.data })
          } else {
            this.$refs.tableInfo.updateTableInfo(response.data)
            this.$message.success('三线表生成成功')
            // 保存历史记录，标记已生成三线表，并保存图表数据
            this.saveHistory(this.sql, { table: true }, { table: response.data })
          }
          // 刷新积分
          this.refreshPoints()
        } else {
          this.$message.warning(response.msg)
        }
      } catch (error) {
        if (error.response) {
          this.$message.error(error.response.data.msg || error.response.data.message || '生成失败，请检查SQL语句格式')
        } else {
          this.$message.error('服务器连接失败，请确保后端服务正在运行')
        }
      }
    },

    generateER() {
      this.$confirm(`此操作将消耗${this.pointsConfig.singleErDiagram}积分，是否继续？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.callApi('er')
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },

    generateTable() {
      this.$confirm(`此操作将消耗${this.pointsConfig.threeLineTable}积分，是否继续？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.callApi('table')
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },

    handleExportDiagram(diagram) {
      const dataUrl = diagram.makeImageData({ scale: 1, background: 'white' })
      const link = document.createElement('a')
      link.download = 'er-diagram.png'
      link.href = dataUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    increasePageView() {
      this.request.get('/pageView/increase', {
        params: { pageName: 'diagram' }
      }).catch(() => {})
    },

    async generateOverallER() {
      if (!this.sql.trim()) {
        this.$message.warning('请输入SQL建表语句')
        return
      }

      // 添加确认提示
      try {
        await this.$confirm(`此操作将消耗${this.pointsConfig.overallErDiagram}积分，是否继续？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch {
        this.$message.info('已取消操作')
        return
      }

      this.activeTab = 'overall'

      // 显示加载提示
      const loading = this.$loading({
        lock: true,
        text: 'AI正在生成总体ER图，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        const response = await this.request.post('/er-diagram/all', { sql: this.sql })
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          this.$refs.overallErDiagram.updateDiagram(response.data)
          this.$message.success('总体ER图生成成功')
          // 保存历史记录，标记已生成总体ER图，并保存图表数据
          this.saveHistory(this.sql, { overall: true }, { overall: response.data })
          // 刷新积分
          this.refreshPoints()
        } else {
          this.$message.warning(response.msg)
        }
      } catch (error) {
        if (error.response) {
          this.$message.error(error.response.data.msg || error.response.data.message || '生成失败，请检查SQL语句格式')
        } else {
          this.$message.error('服务器连接失败，请确保后端服务正在运行')
        }
      } finally {
        // 关闭加载提示
        loading.close()
      }
    },

    // 刷新积分
    refreshPoints() {
      // 使用全局方法刷新积分
      this.$refreshPoints()
    },

    // 保存到历史记录
    saveHistory(sql, generatedTypes = {}, diagramData = {}) {
      const records = localStorage.getItem('erGenerationHistory')
      const history = records ? JSON.parse(records) : []

      // 检查是否已存在相同SQL内容
      const existingIndex = history.findIndex(record =>
        record.type === 'sql' && record.content === sql
      )

      if (existingIndex !== -1) {
        // 如果存在，更新时间戳、合并生成类型和图表数据并移到最前面
        const existingRecord = history[existingIndex]
        existingRecord.timestamp = new Date().getTime()
        existingRecord.generatedTypes = {
          ...existingRecord.generatedTypes,
          ...generatedTypes
        }
        existingRecord.diagramData = {
          ...existingRecord.diagramData,
          ...diagramData
        }
        history.splice(existingIndex, 1)
        history.unshift(existingRecord)
      } else {
        // 如果不存在，添加新记录
        history.unshift({
          timestamp: new Date().getTime(),
          type: 'sql',
          content: sql,
          generatedTypes: generatedTypes,
          diagramData: diagramData
        })
      }

      // 只保留最近50条
      if (history.length > 50) {
        history.splice(50)
      }

      localStorage.setItem('erGenerationHistory', JSON.stringify(history))
    },

    // 从localStorage加载历史记录
    loadHistoryFromLocal() {
      const records = localStorage.getItem('erGenerationHistory')
      const allRecords = records ? JSON.parse(records) : []
      this.totalRecords = allRecords.length
      const startIndex = (this.currentPage - 1) * this.pageSize
      const endIndex = startIndex + this.pageSize
      this.historyList = allRecords.slice(startIndex, endIndex)
    },

    // 加载历史记录到编辑器
    loadHistory(item) {
      this.sql = item.content

      // 根据生成类型决定显示哪个标签页
      const types = item.generatedTypes || {}
      const data = item.diagramData || {}

      // 加载所有已生成的图表数据
      this.$nextTick(() => {
        if (types.er && data.er) {
          this.$refs.erDiagram.updateDiagram(data.er)
        }
        if (types.table && data.table) {
          this.$refs.tableInfo.updateTableInfo(data.table)
        }
        if (types.overall && data.overall) {
          this.$refs.overallErDiagram.updateDiagram(data.overall)
        }
      })

      // 优先显示已生成的内容，按优先级：单个ER图 > 三线表 > 总体ER图
      if (types.er) {
        this.activeTab = 'er'
      } else if (types.table) {
        this.activeTab = 'table'
      } else if (types.overall) {
        this.activeTab = 'overall'
      } else {
        // 如果没有生成过任何类型，默认显示单个ER图标签但不生成
        this.activeTab = 'er'
      }

      this.showHistoryDialog = false
      this.$message.success('已加载历史记录')
    },

    // 页面加载时自动加载最近一个历史记录
    loadLatestHistory() {
      const records = localStorage.getItem('erGenerationHistory')
      if (!records) return

      const history = JSON.parse(records)
      if (history.length === 0) return

      // 获取最近的一条记录（第一条）
      const latestRecord = history[0]

      // 加载SQL内容
      this.sql = latestRecord.content

      // 根据生成类型加载图表数据
      const types = latestRecord.generatedTypes || {}
      const data = latestRecord.diagramData || {}

      // 加载所有已生成的图表数据
      this.$nextTick(() => {
        if (types.er && data.er) {
          this.$refs.erDiagram.updateDiagram(data.er)
        }
        if (types.table && data.table) {
          this.$refs.tableInfo.updateTableInfo(data.table)
        }
        if (types.overall && data.overall) {
          this.$refs.overallErDiagram.updateDiagram(data.overall)
        }
      })

      // 优先显示已生成的内容，按优先级：单个ER图 > 三线表 > 总体ER图
      if (types.er) {
        this.activeTab = 'er'
      } else if (types.table) {
        this.activeTab = 'table'
      } else if (types.overall) {
        this.activeTab = 'overall'
      } else {
        this.activeTab = 'er'
      }
    },

    // 删除历史记录
    deleteHistory(item) {
      this.$confirm('确定删除这条历史记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const records = localStorage.getItem('erGenerationHistory')
        const history = records ? JSON.parse(records) : []
        const index = history.findIndex(r => r.timestamp === item.timestamp)
        if (index > -1) {
          history.splice(index, 1)
          localStorage.setItem('erGenerationHistory', JSON.stringify(history))
          this.loadHistoryFromLocal()
          this.$message.success('删除成功')
        }
      }).catch(() => {})
    },

    // 清空历史记录
    clearHistory() {
      this.$confirm('确定要清空所有历史记录吗？此操作不可恢复。', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('erGenerationHistory')
        this.historyList = []
        this.totalRecords = 0
        this.currentPage = 1
        this.$message.success('历史记录已清空')
      }).catch(() => {})
    },

    // 分页切换
    handlePageChange(page) {
      this.currentPage = page
      this.loadHistoryFromLocal()
    },

    // 查看SQL详情
    viewSqlDetail(sql) {
      this.currentSqlDetail = sql
      this.showSqlDetailDialog = true
    },

    // 复制SQL
    async copySqlDetail() {
      try {
        await navigator.clipboard.writeText(this.currentSqlDetail)
        this.$message.success('SQL已复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败，请手动复制')
      }
    },

    // 格式化时间
    formatTime(timestamp) {
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    collectBusinessDescription() {
      // 这个方法已经不需要了，但保留以防其他地方使用
      const diagram = this.$refs.erDiagram.myDiagram
      if (!diagram) return ''

      let description = '以下是当前数据库的表结构信息：\n\n'

      // 收集实体信息
      const entities = []
      diagram.nodes.each(node => {
        if (node.category === 'Entity') {
          const entityInfo = {
            name: node.data.name,
            attributes: []
          }

          // 收集该实体的属性
          diagram.nodes.each(attr => {
            if (attr.category === 'Attribute' && attr.key.startsWith(node.key + '-')) {
              entityInfo.attributes.push({
                name: attr.data.name,
                type: attr.data.type || 'VARCHAR(100)',
                isPrimaryKey: attr.data.isPrimaryKey || false,
                isNotNull: attr.data.isNotNull || false,
                comment: attr.data.comment || attr.data.name
              })
            }
          })

          entities.push(entityInfo)
        }
      })

      // 生成描述文本
      entities.forEach((entity, index) => {
        description += `表${index + 1}：${entity.name}\n`
        description += '字段：\n'
        entity.attributes.forEach(attr => {
          let attrDesc = `  - ${attr.name}`
          if (attr.type) attrDesc += ` (${attr.type})`
          if (attr.isPrimaryKey) attrDesc += ' [主键]'
          if (attr.isNotNull) attrDesc += ' [非空]'
          if (attr.comment && attr.comment !== attr.name) attrDesc += ` // ${attr.comment}`
          description += attrDesc + '\n'
        })
        description += '\n'
      })

      // 收集关系信息
      const relationships = []
      diagram.nodes.each(node => {
        if (node.category === 'Relationship') {
          relationships.push(node.data.name)
        }
      })

      if (relationships.length > 0) {
        description += `表之间可能存在的关系：${relationships.join(', ')}\n`
      }

      description += '\n请分析这些表之间的关系，并添加合适的外键约束。'

      return description
    }
  }
}
</script>

<style scoped>
.diagram-page {
  display: flex;
  height: calc(100vh - 118px);
  overflow: hidden;
}

.editor-panel {
  width: 320px;
  background: #fff;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  z-index: 1;
}

.panel-header {
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.panel-icon { width: 22px; height: 22px; color: #4f46e5; }

.btn-history {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 13px;
  color: #4f46e5;
  background: #fff;
  border: 1px solid #4f46e5;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-history:hover {
  background: #4f46e5;
  color: #fff;
}

.btn-history svg {
  width: 16px;
  height: 16px;
}

.sql-editor {
  flex: 1;
  background: #111827;
  color: #e5e7eb;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  padding: 16px;
  resize: none;
  border: none;
  outline: none;
  line-height: 1.6;
}

.panel-footer {
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-shrink: 0;
}

.btn-primary, .btn-secondary, .btn-ai {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  border: none;
  transition: background 0.2s;
}

.btn-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-points {
  font-size: 16px;
  font-weight: 600;
  opacity: 0.9;
  white-space: nowrap;
}

.btn-primary { background: #4f46e5; color: #fff; }
.btn-primary:hover { background: #4338ca; }
.btn-secondary { background: #fff; color: #6366f1; border: 1px solid #6366f1; }
.btn-secondary:hover { background: #eef2ff; }
.btn-secondary .btn-points { color: #6366f1; }
.btn-ai { background: #10b981; color: #fff; }
.btn-ai:hover { background: #059669; }
.btn-primary svg, .btn-secondary svg, .btn-ai svg { width: 22px; height: 22px; }

.btn-ai .ai-icon {
  width: 26px;
  height: 26px;
  object-fit: contain;
}

/* AI结果对话框样式 */
::v-deep .er-result-dialog {
  width: 80%;
  max-width: 900px;
}

::v-deep .er-result-dialog .el-message-box__message {
  white-space: pre-wrap;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 13px;
  line-height: 1.6;
  max-height: 60vh;
  overflow-y: auto;
}

.preview-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f9fafb;
  margin-left: 10px;
  border-left: 1px solid #d1d5db;
}

.tabs {
  display: flex;
  gap: 24px;
  padding: 0 24px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.tab {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 0;
  font-size: 16px;
  font-weight: 400;
  color: #6b7280;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
}

.tab svg { width: 22px; height: 22px; }
.tab:hover { color: #374151; }
.tab.active { color: #4f46e5; border-bottom-color: #4f46e5; }

.preview-content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.preview-area {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

/* 历史记录对话框样式 */
.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.history-title {
  font-size: 14px;
  color: #606266;
}

.history-sql-content {
  text-align: left;
}

.history-sql-content pre {
  margin: 0;
  padding: 8px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.6;
  color: #2c3e50;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.pagination-container {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

/* SQL详情对话框样式 */
.sql-detail-content {
  max-height: 500px;
  overflow-y: auto;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
}

.sql-detail-content pre {
  margin: 0;
  font-family: 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.6;
  color: #2c3e50;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
